export default "__VITE_ASSET__BQNeDswM__"